import React, { useContext } from 'react';
import styled from 'styled-components';
import { Card, Grid } from '@material-ui/core';
import {
  Group as GroupIcon,
  InsertDriveFile as InsertDriveFileIcon,
  Warning as WarningIcon
} from '@material-ui/icons';

import CardContent from '../../common/card/CardContent';
import CardTitle from '../../common/card/CardTitle';
import ErrorView from '../../common/views/ErrorView';
import PageTemplate from '../../common/page-template/PageTemplate';
import PageTemplateDashboard from '../../common/page-template/PageTemplateDashboard';
import PageTemplateHeader from '../../common/page-template/PageTemplateHeader';
import { UserContext } from '../../user/User.context';
import TrainingLogCard from '../training/cards/TrainingLogCard';
import AdminToDoCard from './AdminToDoCard';
import CapaChart from './CapaChart';
import DocumentChart from './DocumentChart';
import EmployeeChartCard from './EmployeeChartCard';

const StyledGrid = styled(Grid)`
  .MuiGrid-item {
    .MuiCard-root {
      height: 100%;
      display: flex;
      flex-direction: column;
    }
    .MuiCardContent-root {
      flex: 1;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      & > div {
        width: 100%;
      }
    }
  }
`;

const AdminDashboardPage: React.FC = () => {
  return (
    <PageTemplate>
      <PageTemplateHeader>
        <h2>Admin Dashboard</h2>
      </PageTemplateHeader>
      <PageTemplateDashboard>
        <AdminDashboardPageContent />
      </PageTemplateDashboard>
    </PageTemplate>
  );
};

export default AdminDashboardPage;

export const AdminDashboardPageContent: React.FC = () => {
  const { user } = useContext(UserContext);
  const noRoles: boolean = user?.roles?.length === 0;
  if (noRoles) {
    return (
      <ErrorView
        title='Account Setup Incomplete'
        description='Please contact your administrator to update your account permissions to be able to proceed.'
        icon={<WarningIcon color='disabled' fontSize='inherit' />}
      />
    );
  }
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={8}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <StyledGrid container spacing={3}>
              <Grid item xs={12} md={6}>
                {/* Employee Pie Chart */}
                <EmployeeChartCard />
              </Grid>
              <Grid item xs={12} md={6}>
                {/* Employee Pie Chart */}
                <Card>
                  <CardTitle>
                    <GroupIcon />
                    CAPA Stats
                  </CardTitle>
                  <CardContent>
                    <div>
                      <CapaChart />
                    </div>
                  </CardContent>
                </Card>
              </Grid>
            </StyledGrid>
          </Grid>
          <Grid item xs={12}>
            {/* Document Stats Bar Chart */}
            <Card>
              <CardTitle>
                <InsertDriveFileIcon />
                Documentation Status
              </CardTitle>
              <CardContent>
                <DocumentChart />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md={4}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <AdminToDoCard />
          </Grid>
          <Grid item xs={12}>
            <TrainingLogCard compact />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
